import moment from 'moment/moment';
import { monthArray } from '../lib/formattingData';

export default {
  // 過去12ヶ月分の月オプション
  monthOptions: state => (withCurrentMonth = false) => {
    const latest = state.userState.dataReady.report;
    const array = withCurrentMonth ? monthArray(new Date(), 12) : monthArray(latest, 12);

    return array.map(month => {
      return {
        label: moment(month, 'YYYY-MM').format('YYYY/MM'),
        value: month,
      };
    });
  },
};
